import { createReducer } from '@reduxjs/toolkit'

import { userLogout } from '@/redux/auth/actions'
import {
  getExercisesFailed,
  getExercisesRequest,
  getExercisesSuccess
} from './actions'
import { ExerciseModel } from './types'

interface IExercisesState {
  loading: boolean
  exercisesData: ExerciseModel[]
}

const initialState: IExercisesState = {
  loading: false,
  exercisesData: []
}

const exercisesReducer = createReducer(initialState, builder => {
  builder
    .addCase(getExercisesRequest, state => {
      state.loading = true
    })
    .addCase(getExercisesSuccess, (state, action) => {
      state.loading = false
      state.exercisesData = action.payload.exercisesData
    })
    .addCase(getExercisesFailed, state => {
      state.loading = false
      state.exercisesData = []
    })
    .addCase(userLogout, state => {
      state.loading = false
      state.exercisesData = []
    })
})

export default exercisesReducer
